import PropTypes from "prop-types";
import React, { useState, useContext } from "react";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";

import { FleetContext } from "../../context";

const styles = (theme) => ({
  buttons: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginLeft: "12px",
  },
  label: {
    color: theme.palette.text.secondary,
    "&$focused": { color: theme.palette.text.secondary },
  },
  focused: {}, // material ui sucks, so this empty object is 100% necessary
});

export const FleetTransferModal = (props) => {
  const { modalOpen, handleModalClose, fleetTransfer, selectedVehicles, setLoading, t } = props;

  const { fleets } = useContext(FleetContext);

  const [selectedFleet, setSelectedFleet] = useState(null);

  const closeModal = () => {
    setSelectedFleet(null);
    handleModalClose();
  };

  const transferFleet = async () => {
    closeModal();
    setLoading(true);
    const vehicleObjs = selectedVehicles.map((v) => {
      const vehicleObj = { id: v };
      vehicleObj.fleets = [selectedFleet.uuid4];
      return vehicleObj;
    });

    await fleetTransfer(vehicleObjs);
    setLoading(false);
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={handleModalClose}
      aria-labelledby="passive-hardware-modal"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <div>{t("Ota.FleetTransfer")}</div>
        <Typography>
          {t("Ota.ThisChangeWill")} {selectedVehicles.length} {t("Ota.Vehicles")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <FormControl variant="outlined" margin="dense" size="small" fullWidth>
          <InputLabel
            htmlFor="fleet-select"
            classes={{ root: props.classes.label, focused: props.classes.focused }}
          >
            {t("Ota.DestinationFleet")}
          </InputLabel>
          <Select
            value={selectedFleet || ""}
            label={selectedFleet?.name || ""}
            onChange={(e) => setSelectedFleet(e.target.value)}
            id="fleet-select"
          >
            {fleets.map((fleet) => (
              <MenuItem key={fleet.uuid4} component="div" value={fleet}>
                <Typography>{fleet.name}</Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className={props.classes.buttons}>
          <Button variant="outlined" onClick={closeModal}>
            {t("Ota.Modals.Close")}
          </Button>
          <Button
            variant="outlined"
            onClick={transferFleet}
            className={props.classes.button}
            disabled={!selectedFleet}
          >
            {t("Ota.Modals.Apply")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

FleetTransferModal.propTypes = {
  t: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  fleetTransfer: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  selectedVehicles: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation("common")(withStyles(styles)(FleetTransferModal));
